import { Component, OnInit, ViewChild } from '@angular/core';
import { AggregateService, GridComponent } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { Location } from '@angular/common';

import { MenuFuncionService, ComunidadService, ConsorcioService, TipoGastoService, ServicioGastoService, ExpensaService } from '../../../../src/app/shared/services';
import { MenuFuncionCodes, SearchComunidadRequest, Comunidad, ConceptosRecargo, MetodoRedondeoExpensa, SearchTipoGastoRequest, TipoGasto, UnidadFuncionalTipoGastoPorcentajeItemDto, ConceptosRecargoConstants } from '../../../../src/app/shared/model';
import { ExpensaUnidadFuncionalGastosPorcentajeRequestDto, ServicioGasto, SearchServicioGastoRequest, SaveExpensaConfiguration1RequestDto, TipoGastoComunidadServicioGasto } from '../../../../src/app/shared/model';
import { LocalStorageKeys, SaveExpensaConfiguration2RequestDto, SaveExpensaConfiguration3RequestDto, ComunidadTiposGastos, ExpensaTipoGastoComunidadServicioGasto } from '../../../../src/app/shared/model';

@Component({
    selector: 'app-expensaConfiguracion',
    templateUrl: './expensaConfiguracion.component.html',
    styles: ['./expensaConfiguracion.component.css'],
    providers: [ AggregateService ]
})

export class ExpensaConfiguracionComponent implements OnInit {

    @ViewChild('tipoGastoServicioGrid')
    public tipoGastoServicioGrid: GridComponent;
    @ViewChild('tiposGastosGrid')
    public tiposGastosGrid: GridComponent;

    form0Group: FormGroup;
    form1Group: FormGroup;
    tiposGastosFormGroup: FormGroup;
    form2Group: FormGroup;
    form3Group: FormGroup;

    canView: boolean = false;
    isValidating: boolean = false;
    isSaving: boolean = false;
    hasSearched: boolean = false;
    mostrarSeleccionConceptosRecargo: boolean = false;

    isComunidadSearching: boolean = false;
    isConsorcioSearching: boolean = false;
    isConceptosRecargoSearching: boolean = false;
    isMetodosRedondeoExpensaSearching: boolean = false;
    isTiposGastosSearching: boolean = false;
    isComunidadTipoGastoServicioSearching: boolean = false;
    isComunidadTiposGastoConceptoRecargoSearching: boolean = false;
    isUfSearching: boolean = false;
    isTipoGastoComunidadSearching: boolean = false;
    isServicioSearching: boolean = false;

    ufTipoGastoPorcentajesFlexValue: number = 15;
    hayUfsSinCubrirTotal: boolean = true;

    comunidadList: Comunidad[];
    conceptosRecargoList: ConceptosRecargo[];
    metodosRedondeoExpensaList: MetodoRedondeoExpensa[];
    tiposGastosList: TipoGasto[];
    tipoGastoComunidadList: TipoGasto[];
    ufPorcentajesList: UnidadFuncionalTipoGastoPorcentajeItemDto[];
    serviciosList: ServicioGasto[];
    comunidadTipoGastoServicioList: ExpensaTipoGastoComunidadServicioGasto[];
    comunidadTipoGastoList: ComunidadTiposGastos[];

    comunidadSeleccionada: Comunidad;
    msgError: string = "";
    step: number = 0;

    constructor(
        private formBuilder: FormBuilder,
        private sharedFunctions: SharedFunctions,
        private location: Location,
        private router: Router,
        private route: ActivatedRoute,
        private menuFuncionService: MenuFuncionService,
        private expensaService: ExpensaService,
        private comunidadService: ComunidadService,
        private consorcioService: ConsorcioService,
        private servicioGastoService: ServicioGastoService,
        private tipoGastoService: TipoGastoService
    ) {
        var nav = this.router.getCurrentNavigation();
        this.comunidadSeleccionada = nav?.extras?.state?.comunidad;
    }

    ngOnInit(): void {
        this.isValidating = true;
        this.menuFuncionService.checkMenu(MenuFuncionCodes.EXPENSA_CONFIG).subscribe(data => {
            if (data != null && data.Success && data?.Result) {
                this.isValidating = false;
                this.canView = true;
                this.loadView();
            }
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
        });
    }

    loadView() {
        this.buildForm0();
        this.buildTiposGastosForm();
        this.buildForm1();
        this.buildForm3();

        this.getComunidades();
    }

    buildForm0() {
        this.form0Group = this.formBuilder.group({
            'Comunidad': [this.comunidadSeleccionada, Validators.required]
        });

        if (this.comunidadSeleccionada != null && this.comunidadSeleccionada.Id > 0)
            this.onComunidadConfigure();
    }

    getError0Comunidad() {
        var v = this.form0Group.get('Comunidad');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getComunidades() {
        var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
        if (cId != null && cId.length > 0 && cId > 0)
            cId = Number(cId);

        var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
        this.isComunidadSearching = true; 
    
        this.comunidadService.search(r).subscribe(data => {
          this.isComunidadSearching = false;
          if (data != null)
            this.comunidadList = data?.result;
        },
        (err: HttpErrorResponse) => {
          this.isComunidadSearching = false; 
          this.sharedFunctions.handleError(err);
        });
    }

    compareComunidades(o1: Comunidad, o2: Comunidad): boolean {
        return o1?.Id == o2?.Id;
    }

    getConceptosRecargo() {
        this.isConceptosRecargoSearching = true;
        this.consorcioService.getConceptosRecargo().subscribe(data => {
          this.isConceptosRecargoSearching = false;
          if (data != null)
            this.conceptosRecargoList = data?.Result;
        },
        (err: HttpErrorResponse) => {
          this.isConceptosRecargoSearching = false;
          this.sharedFunctions.handleError(err);
        });
    }
    
    getMetodosRedondeoExpensa() {
        this.isMetodosRedondeoExpensaSearching = true;
        this.consorcioService.getMetodosRedondeoExpensa().subscribe(data => {
          this.isMetodosRedondeoExpensaSearching = false;
          if (data != null)
            this.metodosRedondeoExpensaList = data?.Result;
        },
        (err: HttpErrorResponse) => {
          this.isMetodosRedondeoExpensaSearching = false;
          this.sharedFunctions.handleError(err);
        });
    }

    getTiposGastos() {
        var r = new SearchTipoGastoRequest(null, null, true, "Nombre", null, null, null, null, true);
        this.isTiposGastosSearching = true;
    
        this.tipoGastoService.search(r).subscribe(data => {
          this.isTiposGastosSearching = false;
          if (data != null)
            this.tiposGastosList = data?.result;
        },
          (err: HttpErrorResponse) => {
            this.isTiposGastosSearching = false;
            this.sharedFunctions.handleError(err);
          });
    }

    compareTipoGastos(o1: number, o2: number): boolean {
        return o1 == o2;
    }

    onComunidadConfigure() {
        if (!this.form0Group.valid) {
            this.sharedFunctions.showMessage("Por favor seleccione una comunidad para continuar", "Error");
            return false;
        }

        this.comunidadSeleccionada = this.form0Group.get("Comunidad")?.value;
        this.step = 0;
        this.setStep(1);
    }

    onGridActionFailure(event: any): void {
        this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
    }

    setStep(index: number) {

        if (index == 3 && this.step != 3) {
            if (this.hasStep2Completed()) 
                this.loadStep3();
            else
                index = 2;
        }

        if (index == 2 && this.step != 2) {
            if (this.hasStep1Completed()) 
                this.loadStep2();
            else
                index = 1;
        }

        if (index == 1 && this.step != 1) {
            if (this.comunidadSeleccionada != null && this.comunidadSeleccionada.Id > 0)
                this.loadStep1();
            else
                this.sharedFunctions.showMessage("Por favor seleccione una comunidad para continuar", "Error");
        }

        this.step = index;
    }

    onCancel() {
        this.location.back();
    }

    /**** STEP 1 ****/
    loadStep1() {
        this.getTiposGastos();
        this.getConceptosRecargo();
        this.getMetodosRedondeoExpensa();
        this.getConsorcio(this.comunidadSeleccionada?.ConsorcioId);
        this.getComunidadTiposGastos(this.comunidadSeleccionada?.Id);
        this.getComunidadTiposGastoConceptoRecargo(this.comunidadSeleccionada?.Id);
    }

    buildTiposGastosForm() {
        this.tiposGastosFormGroup = this.formBuilder.group({
          'TipoGastoId': [null, Validators.required],
          'MostrarEnResumenExpensa': [true]
        });
    }

    buildForm1() {
        this.form1Group = this.formBuilder.group({
            'TipoGastos': [null, Validators.required],
            'InteresVencimiento': [null, Validators.required],
            'InteresMensual': [null, Validators.required],
            'MetodoRedondeoExpensa': [null, Validators.required],
            'ConceptosRecargo': [null, Validators.required],
            'TipoGastosConceptosRecargo': [null],
            'ValidarUfTotalPorcentaje': [false],
            'NotaExpensas': [null, Validators.maxLength(1000)],
            'NotaExpensasPie': [null, Validators.maxLength(1000)]
        });
    }

    getConsorcio(id) {
        this.isConsorcioSearching = true;
        this.consorcioService.get(id).subscribe(data => {
            this.isConsorcioSearching = false;
            if (data != null) {
                this.form1Group.patchValue(data.Result);
                this.onConceptoRecargoChange();
            }
        },
        (err: HttpErrorResponse) => {
          this.isConsorcioSearching = false;
          this.sharedFunctions.handleError(err);
        })
    }

    getComunidadTiposGastos(id) {
        this.isTipoGastoComunidadSearching = true;
        this.comunidadService.getTiposGasto(id).subscribe(data => {
            this.isTipoGastoComunidadSearching = false;
            if (data != null)
                this.form1Group.get('TipoGastos')?.setValue(data.Result);
        },
        (err: HttpErrorResponse) => {
          this.isTipoGastoComunidadSearching = false;
          this.sharedFunctions.handleError(err);
        })
    }
    
    getErrorTipoGastoId() {
        return this.tiposGastosFormGroup.get('TipoGastoId')?.hasError('required') ? 'El campo es obligatorio' : '';
    }

    onTipoGastoAdd() {
        if (!this.tiposGastosFormGroup.valid) {
          this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
          return false;
        }

        var tipoGastoList = this.form1Group.get('TipoGastos')?.value;
    
        if (tipoGastoList == null)
            tipoGastoList = [];
    
        var index = tipoGastoList.findIndex(f => f.TipoGastoId == this.tiposGastosFormGroup.get('TipoGastoId')?.value);
        if (index >= 0) {
            tipoGastoList[index] = { 
            ...this.tiposGastosFormGroup.getRawValue(), 
            ...{
              Id: tipoGastoList.Id ?? 0,
              TipoGasto: this.tiposGastosList.find(f => f.Id == this.tiposGastosFormGroup.get('TipoGastoId')?.value)?.Nombre
            }
          };
        }
        else
        tipoGastoList.push({ 
            ...this.tiposGastosFormGroup.getRawValue(), 
            ...{
              Id: 0,
              TipoGasto: this.tiposGastosList.find(f => f.Id == this.tiposGastosFormGroup.get('TipoGastoId')?.value)?.Nombre
            }
          });
        
        this.form1Group.get('TipoGastos')?.setValue(tipoGastoList);
        this.tiposGastosGrid.refresh();
        this.buildTiposGastosForm();
    }
    
    onTipoGastoDelete(item: any) {
        if (item != null && item.index >= 0) {
        var tipoGastoList = this.form1Group.get('TipoGastos')?.value;

            if (tipoGastoList == null)
            tipoGastoList = [];

            tipoGastoList.splice(item.index, 1);
            this.form1Group.get('TipoGastos')?.setValue(tipoGastoList);
            this.tiposGastosGrid.refresh();
        }
    }

    getComunidadTiposGastoConceptoRecargo(id) {
        this.isComunidadTiposGastoConceptoRecargoSearching = true;
        this.comunidadService.getTiposGastoConceptoRecargo(id).subscribe(data => {
            this.isComunidadTiposGastoConceptoRecargoSearching = false;
            if (data != null)
                this.form1Group.get('TipoGastosConceptosRecargo')?.setValue(data.Result?.map(item => item?.TipoGastoId));
        },
        (err: HttpErrorResponse) => {
          this.isComunidadTiposGastoConceptoRecargoSearching = false;
          this.sharedFunctions.handleError(err);
        })
    }

    compareTipoGastosConceptosRecargo(o1: number, o2: number): boolean {
        return o1 == o2;
    }

    onConceptoRecargoChange() {
        this.mostrarSeleccionConceptosRecargo = (this.form1Group.get("ConceptosRecargo")?.value == ConceptosRecargoConstants.GastosSeleccionados);
    }

    getErrorTipoGastos() {
        var v = this.form1Group.get('TipoGastos');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorInteresVencimiento() {
        var v = this.form1Group.get('InteresVencimiento');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorInteresMensual() {
        var v = this.form1Group.get('InteresMensual');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorMetodoRedondeoExpensa() {
        var v = this.form1Group.get('MetodoRedondeoExpensa');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorConceptosRecargo() {
        var v = this.form1Group.get('ConceptosRecargo');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorTipoGastosConceptosRecargo() {
        var v = this.form1Group.get('TipoGastosConceptosRecargo');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getNotaExpensas() {
        var v = this.form1Group.get('NotaExpensas');
        if (v?.hasError('maxlength'))
          return 'Límite de 1000 caracteres alcanzado';
        return '';
    }
    
    getNotaExpensasPie() {
        var v = this.form1Group.get('NotaExpensasPie');
        if (v?.hasError('maxlength'))
            return 'Límite de 1000 caracteres alcanzado';
        return '';
    }

    hasStep1Completed() {
        var valid = (this.form1Group.get('TipoGastos')?.valid &&
            this.form1Group.get('InteresVencimiento')?.valid &&
            this.form1Group.get('InteresMensual')?.valid &&
            this.form1Group.get('MetodoRedondeoExpensa')?.valid &&
            this.form1Group.get('ConceptosRecargo')?.valid &&
            this.form1Group.get('NotaExpensas')?.valid &&
            this.form1Group.get('NotaExpensasPie')?.valid);

        if (valid) {
            var iv = this.form1Group.get('InteresVencimiento')?.value;
            if (iv < 0 || iv > 100) {
                this.sharedFunctions.showMessage("El interés de vencimiento debe tener un valor entre 0 y 100", "Error");
                return false;
            }

            var im = this.form1Group.get('InteresMensual')?.value;
            if (im < 0 || im > 100) {
                this.sharedFunctions.showMessage("El interés mensual debe tener un valor entre 0 y 100", "Error");
                return false;
            }

            var tgcr = this.form1Group.get('TipoGastosConceptosRecargo')?.value;
            if (this.mostrarSeleccionConceptosRecargo && (tgcr == null || tgcr.length == 0)) {
                this.sharedFunctions.showMessage("Debe seleccionar al menos un tipo de gasto para el concepto de recargo seleccionado", "Error");
                return false;
            }
        }

        return valid;
    }

    onStep1Guardar() {
        var r = new SaveExpensaConfiguration1RequestDto(0, 0, [], 0, 0, 0, 0, null, null);
        r = 
        {
            ...this.form1Group.value,
            ComunidadId: this.comunidadSeleccionada.Id, 
            ConsorcioId: this.comunidadSeleccionada.ConsorcioId
        };

        this.isSaving = true;
        this.expensaService.saveConfig1(r).subscribe(data => {
            this.isSaving = false;
            if (data.Success) {
                this.hayUfsSinCubrirTotal = data.Result.HayUfsSinCubrirTotal;
                this.setStep(2);
            }
            else
                this.sharedFunctions.showMessage("Ocurrió un error llevando a cabo la operación. Intente nuevamente o contacte con el administrador del sistema", "Error");
            },
            (err: HttpErrorResponse) => {
                this.isSaving = false;
                this.sharedFunctions.handleError(err, true);
            });
    }

    /**** STEP 2 ****/
    loadStep2() {
        this.getComunidadUnidadesFuncionalesPorcentajes();
    }

    getComunidadUnidadesFuncionalesPorcentajes() {
        var r = new ExpensaUnidadFuncionalGastosPorcentajeRequestDto(this.comunidadSeleccionada?.Id);
        this.isUfSearching = true; 

        this.expensaService.getUnidadFuncionalGastoPorcentajes(r).subscribe(data => {
          this.isUfSearching = false;
          this.ufPorcentajesList = data?.Result?.Porcentajes;

          if (this.ufPorcentajesList != null)
            this.ufTipoGastoPorcentajesFlexValue = 65 / this.ufPorcentajesList.length;
        },
        (err: HttpErrorResponse) => {
          this.isUfSearching = false; 
          this.sharedFunctions.handleError(err, true);
        });
    }

    sumUfPorcentaje(gastoId: number) {
        return this.ufPorcentajesList.reduce(function (accumulator, item) {
            var val = item.TipoGastoPorcentajes.filter(x => x.TipoGastoId == gastoId).reduce(function (accum, g) { return accum + g.Porcentaje; }, 0);
            return accumulator + val;
          }, 0);
    }

    hasStep2Completed() {
        var valid = true;
            // (this.form2Group.get('Nombre')?.valid &&
            // this.form2Group.get('Apellido')?.valid &&
            // this.form2Group.get('TipoDocumentoId')?.valid &&
            // this.form2Group.get('NroDocumento')?.valid &&
            // this.form2Group.get('Cuit')?.valid &&
            // this.form2Group.get('FechaNacimiento')?.valid &&
            // this.form2Group.get('Mail')?.valid &&
            // this.form2Group.get('ConfirmMail')?.valid &&
            // this.form2Group.get('CodigoPais')?.valid &&
            // this.form2Group.get('Movil')?.valid &&
            // this.form2Group.get('Login')?.valid &&
            // this.form2Group.get('Clave')?.valid &&
            // this.form2Group.get('ConfirmClave')?.valid);

        return valid;
    }

    onStep2Guardar() {
        var r = new SaveExpensaConfiguration2RequestDto(this.comunidadSeleccionada?.ConsorcioId ?? 0, this.ufPorcentajesList);
        this.isSaving = true;

        this.expensaService.saveConfig2(r).subscribe(data => {
            this.isSaving = false;
            if (data.Success) {
                this.setStep(3);
            }
            else
                this.sharedFunctions.showMessage("Ocurrió un error llevando a cabo la operación. Intente nuevamente o contacte con el administrador del sistema", "Error");
            },
            (err: HttpErrorResponse) => {
                this.isSaving = false;
                this.sharedFunctions.handleError(err, true);
            });
    }

    /**** STEP 3 ****/
    loadStep3() { 
        this.getServicios();
        this.getTiposGastosByComunidad();
        this.getComunidadTiposGastosServicios();
    }

    buildForm3() {
        this.form3Group = this.formBuilder.group({
            'TipoGasto': [null, Validators.required],
            'ComunidadTipoGastoId': [null],
            'TipoGastoId': [null],
            // 'TipoGasto': [null],
            'Servicios': [null, Validators.required]
        });
    }

    getTiposGastosByComunidad() {
        this.isTipoGastoComunidadSearching = true;
        this.comunidadService.getTiposGasto(this.comunidadSeleccionada?.Id).subscribe(data => {
            this.isTipoGastoComunidadSearching = false;
            this.comunidadTipoGastoList = data?.Result;
        },
        (err: HttpErrorResponse) => {
            this.isTipoGastoComunidadSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    getServicios() {
        var r = new SearchServicioGastoRequest(null, null, true, "Nombre", null, null, null, null, true);
        this.isServicioSearching = true;
    
        this.servicioGastoService.search(r).subscribe(data => {
          this.isServicioSearching = false;
          if (data != null)
            this.serviciosList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isServicioSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    getComunidadTiposGastosServicios() {
        this.isComunidadTipoGastoServicioSearching = true;
        this.comunidadService.getTiposGastoServicios(this.comunidadSeleccionada?.Id).subscribe(data => {
            this.isComunidadTipoGastoServicioSearching = false;
            var itemList = data?.Result;

            if (itemList != null && itemList.length > 0) {
                this.comunidadTipoGastoServicioList = itemList.reduce(function(rv: ExpensaTipoGastoComunidadServicioGasto[], item: TipoGastoComunidadServicioGasto) {
                    var index = rv.findIndex(f => f.TipoGastoComunidadId == item.TipoGastoComunidadId);
                    if (index < 0) {
                     rv.push(new ExpensaTipoGastoComunidadServicioGasto(item.TipoGastoComunidadId, item.TipoGasto, []));
                     index = rv.length - 1;
                    }
                    
                    rv[index].Servicios.push(new ServicioGasto(item.ServicioGastoId, ".", item.ServicioGastoNombre, 
                        //item.ServicioCategoriaGastoId, item.ServicioCategoriaGastoNombre, 
                        null, null, true));
                    return rv;
                }, []);
            }
        },
        (err: HttpErrorResponse) => {
            this.isComunidadTipoGastoServicioSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    compareServicios(o1: number, o2: number): boolean {
        return o1 == o2;
    }

    hasStep3Completed() {
        var valid = (this.comunidadTipoGastoServicioList != null && this.comunidadTipoGastoServicioList.length > 0);
        return valid;
    }

    getError3TipoGastos() {
        var v = this.form3Group.get('TipoGasto');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getError3Servicios() {
        var v = this.form3Group.get('Servicios');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getServiciosConcat(selectedItem: ExpensaTipoGastoComunidadServicioGasto) {
        if (selectedItem != null && selectedItem.Servicios != null)
            return selectedItem?.Servicios?.map(item => item?.Nombre)?.join(", ");
        return "";
    }

    onTipoGasto3Select() {
        var v = this.form3Group.get("TipoGasto")?.value;

        this.form3Group.get("ComunidadTipoGastoId")?.setValue(v?.Id);
        this.form3Group.get("TipoGastoId")?.setValue(v?.TipoGastoId);
        // this.form3Group.get("TipoGasto")?.setValue(v?.TipoGasto);
    }

    onTipoGastoServicioAdd() {
        this.onTipoGasto3Select();

        if (!this.form3Group.valid) {
            this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
            return false;
        }
      
        if (this.comunidadTipoGastoServicioList == null)
            this.comunidadTipoGastoServicioList = [];

        var index = this.comunidadTipoGastoServicioList.findIndex(f => f.TipoGastoComunidadId == this.form3Group.get("ComunidadTipoGastoId")?.value);
        if (index < 0) {
            this.comunidadTipoGastoServicioList.push(new ExpensaTipoGastoComunidadServicioGasto(this.form3Group.get("ComunidadTipoGastoId")?.value, this.form3Group.get("TipoGasto")?.value?.TipoGasto, []));
            index = this.comunidadTipoGastoServicioList.length - 1;
        }

        this.comunidadTipoGastoServicioList[index].Servicios = this.form3Group.get("Servicios")?.value;
        this.tipoGastoServicioGrid.refresh();
    
        this.buildForm3();
    }

    onTipoGastoServicioDelete(item: any) {
        if (item != null && item.index >= 0) {
          if (this.comunidadTipoGastoServicioList == null)
            this.comunidadTipoGastoServicioList = [];
    
          this.comunidadTipoGastoServicioList.splice(item.index, 1);
          this.tipoGastoServicioGrid.refresh();
        }
    }

    onStep3Guardar() {
        if (!this.hasStep3Completed())
            return false;

        var r = new SaveExpensaConfiguration3RequestDto(this.comunidadSeleccionada.Id, this.comunidadSeleccionada?.ConsorcioId ?? 0, this.comunidadTipoGastoServicioList);

        this.isSaving = true;
        this.expensaService.saveConfig3(r).subscribe(data => {
            this.isSaving = false;
            if (data.Success) {
                this.sharedFunctions.showMessage("Se finalizó correctamente la configuración de expensas para la comunidad seleccionada!", "Configuración Exitosa!");
                this.sharedFunctions.reloadCurrentRoute();
            }
            else
                this.sharedFunctions.showMessage("Ocurrió un error llevando a cabo la operación. Intente nuevamente o contacte con el administrador del sistema", "Error");
        },
        (err: HttpErrorResponse) => {
            this.isSaving = false;
            this.sharedFunctions.handleError(err, true);
        });
    }
}